@if (isLoading) {
  <po-loading-overlay></po-loading-overlay>
}
<po-page-default p-title="Configurações de Automações do Sistema" [p-breadcrumb]="breadcrumb"
  p-subtitle="Configure opções de integração e configurações gerais da aplicação.">
  <hr />

  <div class="po-row">
    <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
      <span class="an an-robot"></span>
    Replicação de Diretórios</span>

    <div class="po-row">
      <po-container p-title="Cópia de Diretório Untário" class="po-lg-12 po-md-12 po-sm-12">
        <po-input class="po-lg-4" [(ngModel)]="diretorioSource" p-label="Diretório Cópia"
          p-placeholder="Informe um Diretório Ex. (Y:\\2024)"
          p-help="Informe um diretório existente no servidor." p-required="true" p-name="dataEntrega">
        </po-input>
        <po-input class="po-lg-4" [(ngModel)]="diretorioDestino" p-label="Diretório Destino"
          p-placeholder="Informe um Diretório"
          p-help="Informe o nome do diretório que será criado no servidor" p-required="true"
          p-name="dataEntrega">
        </po-input>
        <po-button class="po-lg-4 po-mt-4" p-label="Gerar Estrutura" (p-click)="replicateDirectory()"
        ></po-button>
        <br />

      </po-container>
    </div>
  </div>
  <br />
  <div class="po-row">
    <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
      <span class="an an-robot"></span>
    Replicação de Empresas</span>

    <div class="po-row">
      <po-container p-title="Cópia de Diretórios em Massa" class="po-lg-12 po-md-12 po-sm-12">
        <po-input class="po-lg-4" [(ngModel)]="costumerDiretorioSource" p-label="Diretório Raiz das Empresas"
          p-placeholder="Informe um Diretório Ex. (Y:\\2024)"
          p-help="Diretório onde as empresas estão armazenadas." p-required="true" p-name="dataEntrega">
        </po-input>
        <po-input class="po-lg-4" [(ngModel)]="costumerAno" p-label="Ano Copiado (Ex: 2024, 2025, etc)"
          p-placeholder="Informe um Diretório"
          p-help="Diretório copiado no contexto da empresa (apenas o nome da pasta)" p-required="true"
          p-name="dataEntrega">
        </po-input>
        <po-input class="po-lg-4" [(ngModel)]="costumerDiretorioDestino"
          p-label="Ano Destino (Ex: 2024, 2025, etc)" p-placeholder="Informe um Diretório"
          p-help="Diretório que será criado no contexto da empresa (apenas o nome da pasta)" p-required="true"
          p-name="dataEntrega">
        </po-input>
        <po-button class="po-lg-4 po-mt-4" p-label="Gerar Estrutura" (p-click)="replicateCostumer()"
        ></po-button>
        <br />

        <div class="po-lg-11 po-md-9 po-sm-8">
          <br/>
          <p class="po-font-text-large">Nesta etapa o sistema tentará realizar as seguintes
            operações:
            <br/>
            <br/>
          </p>
          <p><b> &nbsp;&nbsp; - Localizar as empresas no diretório selecionado.</b></p>
          <p><b> &nbsp;&nbsp; - Verificar uma pasta com o nome do ano informado.</b></p>
          <p><b> &nbsp;&nbsp; - Replicar a estrutura dentro dessa pasta para o ano destino informado.</b></p>
          <br/>
          <br/>
          <p class="po-font-text-large">Depois de enviado, <b class="text-green">o sistema enviará os comandos para o Worker, </b>
          e esse processo poderá demorar alguns minutos.
          <br/>
        </p>
      </div>

    </po-container>
  </div>


</div>


<br />


</po-page-default>
